<template>
	<div class="comme">
		<!-- 选项列表 -->
		<div class="comme_radio_list" v-if="info.options.length <=  6">
			<div v-for="(item,index) in info.options" @click="changeCheckActive(item.optionId)" :key="index">
			<div :class="checkList.some(i => i == item.optionId) ? 'radio_list_item__active' : 'radio_list_item'" v-if="item.optionId">
				<el-tooltip class="item" effect="light" :content="item.optionExplain" placement="top-start">
                    <span v-if="item.optionExplain && item.optionExplain != ''">{{ item.optionName }}</span>
                </el-tooltip>
                <span v-if="item.optionExplain == '' || !item.optionExplain">{{ item.optionName }}</span>
			</div>
			</div>
		</div>
		<div v-else>
			<div  @click="showSelect" v-if="!info.fieIdValue">
				<div class="radio_list_item__choose">
					<span>请选择</span>
				</div>
			</div>
			<div style="display: flex;"  @click="showSelect" v-else>
				<span style="line-height: 35px;">你选择了：{{ info.fieIdValue }}</span>
				<div class="radio_list_item__choose radio_list_item__choosed" style="width: 100px;margin-left: 20px">
					<span>编辑</span>
				</div>
			</div>
		</div>
		<selectPop ref="selectPop" @close="closeSelect" @update="updateCheckBox" v-if="selectPopStatus"></selectPop>
	</div>
</template>

<script>
import selectPop from './selectPop.vue';
	export default {
		components:{selectPop},
		props: ['info', 'index'],
		data() {
			return {
				selectPopStatus: false,
				checkList: [],
			}
		},
		mounted() {
			this.checkList = this.info.optionId || []
		},
		watch: {
			info: {
				handler(newValue) {
					this.checkList = newValue.optionId || []
				},
				deep: true,
				immediate: true,
			}
		},
		methods: {
			showSelect(){
				this.selectPopStatus = true
				this.$nextTick(() => {
					this.$refs.selectPop.init(this.info,this.index)
				})
			},
			closeSelect(){
				this.selectPopStatus = false
			},
			updateCheckBox(data){
				this.selectPopStatus = false
				this.$emit('changebox', data)
			},
			// 切换选择框状态
			changeCheckActive(id) {
				const index = this.checkList.findIndex(item => item == id)
				if(index >= 0) {
					this.checkList.splice(index, 1)
				} else {
					this.checkList.push(id)
				}
				//存储字段值列表
				let valueList = []
				this.info.options.forEach(item => {
					if(this.checkList.some(i => i == item.optionId)) {
						valueList.push(item.optionName)
					}
				})
                this.$forceUpdate()
				let obj = {
					index: this.index,
					fieIdValue: valueList.join(','),
					optionId: this.checkList,
					fieIdId: this.info.fieIdId,
					options: this.info.options,
					valueId: this.checkList.join(',')
				}
				this.$emit('changebox', obj)
			}
		}
	}
</script>

<style lang="scss" scoped>
.comme_radio_list {
  display: flex;
  flex-flow: row wrap;
}

.radio_list_item {
  cursor: pointer;
  min-width: 134px;
  min-height: 35px;
  border-radius: 7px;
  border: 1px solid #c4c4c4;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #666666;
  margin-right: 25px;
  margin-bottom: 15px;
}

.radio_list_item__active {
  cursor: pointer;
  min-width: 134px;
  min-height: 35px;
  background: #4d6fff;
  border-radius: 7px;
  border: 1px solid #4d6fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #ffffff;
  margin-right: 25px;
  margin-bottom: 15px;
}
.radio_list_item__choose{
	cursor: pointer;
	width: 134px;
	min-height: 35px;
	border-radius: 7px;
	border: 1px solid #C4C4C4;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 14px;
	margin-right: 25px;
	margin-bottom: 15px;
}
.radio_list_item__choosed {
	color: #ffffff;
	background-color: #4D6FFF;
	border: none;
}
</style>